import React, { Component } from "react";
import { getReceivedItems } from "../../../../../../services/inventory/itemsMovement";
import CustomDataTable from "../../../../../../partials/content/CustomDataTable";
import Illustration from "../../../../../../partials/content/Illustration";
import { formatDate } from "../../../../../../utils/utils";
import ResponsiveEllipsis from "../../../../../../partials/content/ResponsiveEllipsis";
import withGlobalData from "../../../../common/withGlobalData";
import BootstrapTooltip from "../../../../../../partials/content/BootstrapTooltip";
class PoGoodsReceived extends Component {
  state = {
    reload: this.props.globalData.reload,
    dataSummary: {},
    receivedItems: [],
    itemReceivedDetailColumn: [
      {
        header: "Created At",
        field: "CreatedAt",
        type: "datetime",
      },
      {
        header: "Created By",
        field: "createdByName",
        type: "string",
      },
      {
        header: "Updated At",
        field: "UpdatedAt",
        type: "datetime",
      },
      {
        header: "Updated By",
        field: "updatedByName",
        type: "string",
      },
    ],
  };

  componentDidMount() {
    this.getReceivedItems();
  }

  componentDidUpdate() {
    const { globalData } = this.props;
    const { reload } = this.state;
    if (globalData.reload !== reload) {
      this.getReceivedItems();
      this.setState({ reload: globalData.reload });
    }
  }

  async getReceivedItems() {
    const { poID = 0, poItemID = 0 } = this.props;
    const response = await getReceivedItems("PO", poID, poItemID);
    const { data } = response.data;
    this.setState({
      dataSummary: data.dataSummary,
      receivedItems: data.itemsMovement,
    });
  }

  render() {
    const { receivedItems, itemReceivedDetailColumn } = this.state;
    return (
      <React.Fragment>
        {receivedItems.length ? (
          <React.Fragment>
            <CustomDataTable
              data={receivedItems}
              dataDetailColumns={itemReceivedDetailColumn}
              onRefreshData={() => {
                this.getReceivedItems();
              }}
              columns={[
                {
                  header: "Receive ID",
                  field: "ID",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Received Date",
                  field: "moveDate",
                  body: (rowData) => formatDate(rowData.moveDate),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Item Type",
                  field: "itemTypeName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.itemTypeName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                  hidden: true,
                },
                {
                  header: "Item Code",
                  field: "itemCode",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.itemType > 0 ? (
                        <span>
                          <BootstrapTooltip title={rowData.itemTypeName}>
                            <span className="mr-2">
                              <i
                                className={
                                  rowData.itemType === 1
                                    ? "fas fa-boxes text-success"
                                    : rowData.itemType === 2
                                    ? "fas fa-tools text-primary"
                                    : rowData.itemType === 3
                                    ? "fas fa-building text-info"
                                    : rowData.itemType === 4
                                    ? "fas fa-boxes text-warning"
                                    : rowData.itemType === 5
                                    ? "fas fa-boxes text-danger"
                                    : null
                                }
                              ></i>
                            </span>
                          </BootstrapTooltip>
                          <span>
                            <ResponsiveEllipsis
                              text={rowData.itemCode}
                              maxLine="1"
                              displayInline
                            />
                          </span>
                        </span>
                      ) : (
                        <React.Fragment>
                          <ResponsiveEllipsis
                            text={rowData.itemCode}
                            maxLine="1"
                          />
                        </React.Fragment>
                      )}
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Item Name",
                  field: "itemName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis text={rowData.itemName} maxLine="1" />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Quantity",
                  field: "qty",
                  body: (rowData) => (
                    <div>
                      {rowData.qty} {rowData.uom.uomName}
                    </div>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Unit",
                  field: "uom.uomName",
                  body: null,
                  sortable: true,
                  filter: true,
                  hidden: true,
                },
                {
                  header: "Batch ID",
                  field: "batchID",
                  body: null,
                  sortable: true,
                  filter: true,
                },
              ]}
            />
          </React.Fragment>
        ) : (
          <React.Fragment>
            <Illustration
              imageSource="INVIFO Inventory.png"
              guidance={`You don't have any Goods Received for this purchase order yet`}
              guidanceLeftIcon="fas fa-info-circle kt-font-warning"
              size="md"
            ></Illustration>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

export default withGlobalData(PoGoodsReceived);
